// Import CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "tippy.js/dist/tippy.css";
import "@css/app.css";

// Register loading indicators
import "ldrs/ring";

// Swiper
import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Youtube from '@tiptap/extension-youtube'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import Heading from '@tiptap/extension-heading';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Vimeo } from '@fourwaves/tiptap-extension-vimeo';
import { LinkPreview } from './linkPreview';


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="readonly-editor-"]').forEach(editorEl => {
    const postId = editorEl.id.replace('readonly-editor-', '')
    const jsonScript = document.getElementById(`readonly-content-${postId}`)
    if (!jsonScript) return;

    const content = JSON.parse(jsonScript.textContent || '{}')

    new Editor({
      element: editorEl,
      editable: false,
      content,
      extensions:
        [
          StarterKit.configure({
            bulletList: false,
            orderedList: false,
            listItem: false,
          }),
          Placeholder.configure({
            placeholder: "Start et innlegg"
          }),
          BulletList,
          OrderedList,
          ListItem,
          Heading.configure({
            levels: [1, 2, 3, 4],
          }),
          Link.configure({
            openOnClick: false,
          }),
          Image,
          Youtube,
          Vimeo,
          LinkPreview
        ],
    })
  })

  const swiperMap = new Map<string, Swiper>();
  document.querySelectorAll<HTMLImageElement>('.js-gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const galleryId = thumb.dataset.galleryId!;
      const startIndex = parseInt(thumb.dataset.index!, 10);
      openGallery(galleryId, startIndex);
    });
  });

  function openGallery(modalId: string, startIndex: number) {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    modal.classList.remove('hidden');

    const container = modal.querySelector<HTMLElement>('.js-gallery-swiper');
    if (!container) return;

    const existing = swiperMap.get(modalId);
    if (existing) {
      existing.destroy(true, true);
    }

    const swiper = new Swiper(container, {
      initialSlide: startIndex,
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next-custom",
        prevEl: ".swiper-button-prev-custom",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        bulletActiveClass: "!bg-ux-blue !opacity-100 border-ux-blue",
        bulletClass:
          "w-3 h-3 inline-block rounded-full border border-neutral-200 mx-1",
      },
    });

    swiperMap.set(modalId, swiper);
  }

  document.querySelectorAll<HTMLElement>('.js-gallery-modal').forEach(modal => {
    const btn = modal.querySelector<HTMLElement>('.js-gallery-close');
    btn?.addEventListener('click', () => modal.classList.add('hidden'));
    modal.addEventListener('click', e => {
      if (e.target === modal) {
        modal.classList.add('hidden');
      }
    });
  });
});

const swiper = new Swiper(".swiper", {
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".swiper-button-next-custom",
    prevEl: ".swiper-button-prev-custom",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    bulletActiveClass: "!bg-ux-blue !opacity-100 border-ux-blue",
    bulletClass:
      "w-3 h-3 inline-block rounded-full border border-neutral-200 mx-1",
  },
});

const productSwiper = new Swiper(".product-carousel", {
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".product-swiper-button-next",
    prevEl: ".product-swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const productLightboxThumbs = new Swiper(".product-lightbox-thumbs", {
  spaceBetween: 20,
  slidesPerView: 4.8,
  freeMode: true,
  watchSlidesProgress: true,
});

const productLightboxSwiper = new Swiper(".product-lightbox-carousel", {
  modules: [Navigation, Thumbs],
  navigation: {
    nextEl: ".product-swiper-button-next",
    prevEl: ".product-swiper-button-prev",
  },
  thumbs: {
    swiper: productLightboxThumbs,
  }
});


const carousel = new Swiper(".carousel", {
  modules: [Navigation],
  slidesPerView: "auto",
  spaceBetween: 30,
  navigation: {
    nextEl: ".carousel-button-next",
    prevEl: ".carousel-button-prev",
  },
});

import tippy from "tippy.js";
const profileMenu = document.querySelector('#profile-menu');
const profileMenuButton = document.querySelector('#profile-menu-button');
tippy('#profile-menu-button', {
  placement: 'bottom-start',
  theme: 'vestlandshus',
  arrow: false,
  trigger: 'click',
  interactive: true,
  content: profileMenu?.innerHTML,
  allowHTML: true,
});

const notificationsMenu = document.querySelector('#profile-notifications');
const profileNotificationsButton = document.querySelector('#profile-notifications-button');
tippy('#profile-notifications-button', {
  placement: 'bottom-start',
  theme: 'vestlandshus',
  arrow: false,
  trigger: 'click',
  interactive: true,
  content: notificationsMenu?.innerHTML,
  allowHTML: true,
});

// Vue JS
import { createApp } from "vue";
import { createPinia } from "pinia";
import ProductDatabase from "./productDatabase/components/ProductDatabase.vue";
import ImageDatabase from "./imageDatabase//components/ImageDatabase.vue";
import { getLinkPreview, getPreviewFromContent } from "link-preview-js";
if (document.getElementById('product-database')) {
  const productDatabaseApp = createApp(ProductDatabase);
  productDatabaseApp.use(createPinia());
  productDatabaseApp.mount("#product-database");
}
if (document.getElementById('image-database')) {
  const imageDatabaseApp = createApp(ImageDatabase);
  imageDatabaseApp.use(createPinia());
  imageDatabaseApp.mount("#image-database");
}

// Put Alpine last, so that it has access to other JS modules
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

const editorInstances: { [key: string]: Editor } = {}

document.querySelectorAll('.tiptap-editor-comment, .tiptap-editor-add-post, .tiptap-editor-edit-post').forEach((element) => {
  const id = element.id
  const input = document.querySelector(`#tiptap-input-${id}`) as HTMLInputElement;
  let uploadedImages = [];
  let existingImages = [];
  let removedImages = [];
  let uploadedVideos = [];
  let existingVideos = [];
  let removedVideos = [];
  let uploadedFiles = [];
  let existingFiles = [];
  let removedFiles = [];
  document.querySelectorAll(`#image-preview-wrapper-${id} img`).forEach((img) => {
    existingImages.push(img.src);
  });

  document.querySelectorAll(`#video-preview-wrapper-${id} video`).forEach((vid) => {
    existingVideos.push(vid.src);
  });

  document.querySelectorAll(`#file-preview-wrapper-${id} img`).forEach((file) => {
    existingFiles.push(file.src);
  });

  updateVideoPreviewUI();
  updateImagePreviewUI();
  updateFilePreviewUI();

  const contentScript = document.getElementById(`editor-content-${id}`);
  const content = contentScript ? JSON.parse(contentScript.innerHTML) : '';

  const editor = new Editor({
    element: element as HTMLElement,
    editorProps: {
      attributes: {
        class: 'focus:outline-none m-16 min-h-[100px]'
      },
    },
    extensions: [
      StarterKit.configure({
        bulletList: false,
        orderedList: false,
        listItem: false,
      }),
      Placeholder.configure({
        placeholder: "Start et innlegg"
      }),
      BulletList,
      OrderedList,
      ListItem,
      Link.configure({
        openOnClick: false,
      }),
      Image,
      Youtube,
      Vimeo,
      LinkPreview
    ],
    content: content
  });

  editorInstances[id] = editor;

  const form = element.closest('form');
  if (form) {
    form.addEventListener('submit', () => {
      input.value = editor.getHTML();

      uploadedImages.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[uploadedImages][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-uploaded-image');
        form.appendChild(hiddenInput);
      });

      removedImages.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[removedImages][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-removed-image');
        form.appendChild(hiddenInput);
      });

      uploadedVideos.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[uploadedVideos][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-uploaded-video');
        form.appendChild(hiddenInput);
      });

      removedVideos.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[removedVideos][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-removed-video');
        form.appendChild(hiddenInput);
      });

      uploadedFiles.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[uploadedFiles][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-uploaded-file');
        form.appendChild(hiddenInput);
      });

      removedFiles.forEach((url) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'fields[removedFiles][]';
        hiddenInput.value = url;
        hiddenInput.classList.add('temp-removed-file');
        form.appendChild(hiddenInput);
      });
    });
  }

  const wrapper = element.closest('.editor-wrapper');
  const toolbar = wrapper?.querySelector('.tiptap-toolbar');

  if (toolbar) {
    const updateToolbarState = () => {
      toolbar.querySelectorAll('button').forEach((btn) => {
        const action = btn.getAttribute('data-action');
        let isActive = false;

        switch (action) {
          case 'bold':
            isActive = editor.isActive('bold');
            break;
          case 'italic':
            isActive = editor.isActive('italic');
            break;
          case 'bulletList':
            isActive = editor.isActive('bulletList');
            break;
          case 'orderedList':
            isActive = editor.isActive('orderedList');
            break;
          case 'heading':
            const level = btn.getAttribute('data-level');
            if (level) {
              isActive = editor.isActive('heading', { level: parseInt(level) });
            }
            break;
          case 'paragraph':
            isActive = editor.isActive('paragraph');
            break;
        }

        btn.classList.toggle('active', isActive);
      });
    };

    editor.on('selectionUpdate', updateToolbarState);

    toolbar.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', (event) => {
        const action = button.getAttribute('data-action');
        switch (action) {
          case 'bold':
            editor.chain().focus().toggleBold().run();
            break;
          case 'italic':
            editor.chain().focus().toggleItalic().run();
            break;
          case 'bulletList':
            editor.chain().focus().toggleBulletList().run();
            break;
          case 'orderedList':
            editor.chain().focus().toggleOrderedList().run();
            break;
          case 'heading':
            editor.chain().focus().toggleHeading({ level: parseInt(button.getAttribute('data-level')) }).run();
            break;
          case 'paragraph':
            editor.chain().focus().setParagraph().run();
            break;
          case 'fontSize':
            editor.chain().focus().setMark('textStyle', { fontSize: button.getAttribute('data-size') }).run();
            break;
          case 'addRichtextImage': {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';

            fileInput.onchange = async () => {
              const files = fileInput.files;
              if (!files || files.length === 0) return;

              const file = files[0];

              const formData = new FormData();
              formData.append('images[]', file);

              try {
                const res = await fetch('/actions/posts/post/upload', {
                  method: 'POST',
                  headers: {
                    [window.csrfTokenName as string]: window.csrfToken as string
                  },
                  body: formData
                });


                if (!res.ok) {
                  throw new Error('Server error: ' + res.status);
                }

                const data = await res.json();

                if (data.success && Array.isArray(data.urls)) {
                  // Insert the image into Tiptap editor
                  editor.chain().focus().setImage({
                    src: data.urls[0],
                    alt: file.name,
                    title: file.name,
                  }).run();
                } else {
                  alert('Feil ved opplasting av bilder.');
                }
              } catch (err) {
                console.error('Upload failed', err);
                alert('Noe gikk galt ved bildeopplasting.');
              }
            };

            // Trigger the file selector popup
            fileInput.click();
            break;
          }
          case 'addLink': {
            const url = prompt('Legg inn URL');
            if (url) {
              // Insert the link into the editor first
              // editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
              const text = 'Link';
              editor.chain()
                .focus()
                .insertContent({
                  type: 'text',
                  text,
                  marks: [
                    {
                      type: 'link',
                      attrs: { href: url },
                    },
                  ],
                })
                .run();

              // Fetch the preview metadata
              fetch('/actions/posts/link-preview/get-preview', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  [window.csrfTokenName as string]: window.csrfToken as string
                },
                body: JSON.stringify({ url: url })
              })
                .then(res => res.json())
                .then(data => {
                  if (data.success && data.preview) {
                    const preview = data.preview
                    // Small delay to ensure the link was rendered
                    setTimeout(() => {
                      editor
                        .chain()
                        .focus()
                        .insertContent({
                          type: 'linkPreview',
                          attrs: {
                            url,
                            title: preview.title,
                            description: preview.description,
                            image: preview.image,
                          }
                        })
                        .run();
                    }, 100);
                  }
                });

              document.addEventListener('click', function (e) {
                const target = e.target as HTMLElement;
                if (target.classList.contains('remove-link-preview')) {
                  const preview = target.closest('.link-preview-inline');
                  if (preview) {
                    preview.remove();
                  }
                }
              });
            }
            break;
          }
          case 'addImage': {
            const button = event.target.closest('button'); // ← climb up to nearest button
            if (!button) return; // Click wasn't on a button or inside a button

            if (button.dataset.action !== 'addImage') {
              return; // Only handle 'addImage' buttons
            }

            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.multiple = true;

            fileInput.onchange = async () => {
              const files = fileInput.files;
              if (!files || files.length === 0) return;

              const formData = new FormData();

              for (const file of files) {
                formData.append('images[]', file);
              }

              try {
                const res = await fetch('/actions/posts/post/upload', {
                  method: 'POST',
                  headers: {
                    [window.csrfTokenName as string]: window.csrfToken as string
                  },
                  body: formData
                });


                if (!res.ok) {
                  throw new Error('Server error: ' + res.status);
                }

                const data = await res.json();

                if (data.success && Array.isArray(data.urls)) {
                  const editorWrapper = button.closest('.editor-wrapper');
                  const form = editorWrapper.querySelector('form');

                  data.urls.forEach((url) => {
                    handleImageUploadResponse(url);
                    // editor.chain().focus().setImage({ src: url }).run();
                  });
                } else {
                  alert('Feil ved opplasting av bilder.');
                }
              } catch (err) {
                console.error('Upload failed', err);
                alert('Noe gikk galt ved bildeopplasting.');
              }
            };

            fileInput.click();
            break;
          }
          case 'addYoutube': {
            const url = prompt('Enter YouTube URL');
            if (url) {
              editor.chain().focus().setYoutubeVideo({ src: url }).run();
            }
            break;
          }
          case 'addVimeo': {
            const url = prompt('Enter Vimeo URL');
            if (url) {
              editor.chain().focus().setVimeoVideo({ src: url }).run();
            }
            break;
          }
          case 'addFile': {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'application/pdf';
            fileInput.multiple = true;

            fileInput.onchange = async () => {
              const files = fileInput.files;
              if (!files || files.length === 0) return;

              const formData = new FormData();
              for (const file of files) {
                formData.append('files[]', file);
              }

              try {
                const res = await fetch('/actions/posts/post/upload-file', {
                  method: 'POST',
                  headers: {
                    [window.csrfTokenName]: window.csrfToken
                  },
                  body: formData
                });


                if (!res.ok) throw new Error('Server error: ' + res.status);

                const data = await res.json();

                if (data.success && Array.isArray(data.urls)) {
                  data.urls.forEach((url) => {
                    uploadedFiles.push(url);
                  });
                  updateFilePreviewUI();
                } else {
                  alert('Feil ved opplasting av fil.');
                }
              } catch (err) {
                console.error('Upload failed', err);
                alert('Noe gikk galt ved filopplasting.');
              }
            };

            fileInput.click();
            break;
          }
          case 'addVideo': {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'video/*';
            fileInput.multiple = true;

            fileInput.onchange = async () => {
              const files = fileInput.files;
              if (!files || files.length === 0) return;

              const formData = new FormData();
              for (const file of files) {
                formData.append('videos[]', file);
              }

              try {
                const res = await fetch('/actions/posts/post/upload-video', {
                  method: 'POST',
                  headers: {
                    [window.csrfTokenName]: window.csrfToken
                  },
                  body: formData
                });

                if (!res.ok) throw new Error('Server error: ' + res.status);

                const data = await res.json();

                if (data.success && Array.isArray(data.urls)) {
                  data.urls.forEach((url) => {
                    uploadedVideos.push(url);
                  });
                  updateVideoPreviewUI();
                } else {
                  alert('Feil ved opplasting av video.');
                }
              } catch (err) {
                console.error('Upload failed', err);
                alert('Noe gikk galt ved videoopplasting.');
              }
            };

            fileInput.click();
            break;
          }
        }
        updateToolbarState();
      });
    });
  }

  function handleImageUploadResponse(url) {
    uploadedImages.push(url);
    updateImagePreviewUI();
  }

  function updateImagePreviewUI() {
    const container = document.getElementById(`image-preview-wrapper-${id}`);
    container.innerHTML = '';

    // Render existing images (if not marked as removed)
    existingImages.forEach((imageUrl) => {
      if (removedImages.includes(imageUrl)) return;

      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');
      wrapper.dataset.imageUrl = imageUrl;

      wrapper.innerHTML = `
      <img src="${imageUrl}" class="w-[100px] h-[100px] object-contain rounded-md" />
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        removedImages.push(imageUrl);

        // Add hidden input so it's passed in the form
        const removedInput = document.createElement('input');
        removedInput.type = 'hidden';
        removedInput.name = 'fields[removedImages][]';
        removedInput.value = imageUrl;
        removedInput.classList.add('temp-removed-image');

        container.closest('form').appendChild(removedInput);

        updateImagePreviewUI(); // Refresh UI
      });

      container.appendChild(wrapper);
    });

    // Render newly uploaded images
    uploadedImages.forEach((imageUrl, index) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');

      wrapper.innerHTML = `
      <img src="${imageUrl}" class="w-[100px] h-[100px] object-contain rounded-md" />
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block" data-index="${index}">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        uploadedImages.splice(index, 1);
        updateImagePreviewUI();
      });

      container.appendChild(wrapper);
    });
  }

  function updateVideoPreviewUI() {
    const container = document.getElementById(`video-preview-wrapper-${id}`);
    if (!container) return;
    container.innerHTML = '';

    existingVideos.forEach((videoUrl) => {
      if (removedVideos.includes(videoUrl)) return;

      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');
      wrapper.dataset.videoUrl = videoUrl;

      wrapper.innerHTML = `
      <video src="${videoUrl}" controls class="w-[150px] h-[100px] rounded-md object-contain"></video>
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        removedVideos.push(videoUrl);
        const removedInput = document.createElement('input');
        removedInput.type = 'hidden';
        removedInput.name = 'fields[removedVideos][]';
        removedInput.value = videoUrl;
        removedInput.classList.add('temp-removed-video');

        container.closest('form').appendChild(removedInput);

        updateVideoPreviewUI();
      });

      container.appendChild(wrapper);
    });

    uploadedVideos.forEach((videoUrl, index) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');

      wrapper.innerHTML = `
      <video src="${videoUrl}" controls class="w-[150px] h-[100px] rounded-md object-contain"></video>
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block" data-index="${index}">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        uploadedVideos.splice(index, 1);
        updateVideoPreviewUI();
      });

      container.appendChild(wrapper);
    });
  }

  function updateFilePreviewUI() {
    const container = document.getElementById(`file-preview-wrapper-${id}`);
    if (!container) return;
    container.innerHTML = '';

    existingFiles.forEach((fileUrl) => {

      const fileName = fileUrl.split('/').pop();

      if (removedFiles.includes(fileUrl)) return;

      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');
      wrapper.dataset.fileUrl = fileUrl;

      wrapper.innerHTML = `
        <a href="${fileUrl}" target="_blank" class="block w-[100px]">
					<div class="w-full h-[100px] rounded-md overflow-hidden">
						<img src="/uploads/pdf-placeholder.png" alt="PDF" class="w-full h-full object-contain hover:opacity-60 transition"/>
					</div>
          <p class="text-xs mt-1 text-center truncate max-w-[100px]" title="${fileName}">${fileName}</p>
				</a>
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        removedFiles.push(fileUrl);
        const removedInput = document.createElement('input');
        removedInput.type = 'hidden';
        removedInput.name = 'fields[removedFiles][]';
        removedInput.value = fileUrl;
        removedInput.classList.add('temp-removed-files');

        container.closest('form').appendChild(removedInput);

        updateFilePreviewUI();
      });

      container.appendChild(wrapper);
    });

    uploadedFiles.forEach((fileUrl, index) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('relative', 'group');

      const fileName = fileUrl.split('/').pop();

      wrapper.innerHTML = `
      <a href="${fileUrl}" target="_blank" class="block w-[150px]">
					<div class="w-full h-[100px] rounded-md overflow-hidden">
						<img src="/uploads/pdf-placeholder.png" alt="PDF" class="w-full h-full object-contain hover:opacity-60 transition"/>
					</div>
          <p class="text-xs mt-1 text-center truncate max-w-[100px]" title="${fileName}">${fileName}</p>
				</a>
      <button type="button" class="absolute top-0 right-0 p-1 bg-white rounded hidden group-hover:block" data-index="${index}">✕</button>
    `;

      const button = wrapper.querySelector('button');
      button.addEventListener('click', () => {
        uploadedFiles.splice(index, 1);
        updateFilePreviewUI();
      });

      container.appendChild(wrapper);
    });
  }
});
